export default class LinkedInPostDto {
    private _code: string;
    private _postText: string;
    private _entityOepId: string;
    private _processId: string;

    constructor(data: any) {
        this._code = data.code;
        this._postText = data.postText;
        this._entityOepId = data.entityOepId;
        this._processId = data.processId;
    }

    public get code(): string {
        return this._code;
    }

    public get postText(): string {
        return this._postText;
    }

    public get entityOepId(): string {
        return this._entityOepId;
    }

    public get processId(): string {
        return this._processId;
    }
    public toServer() {
        return {
            code: this._code,
            postText: this._postText,
            entityOepId: this._entityOepId,
            processId: this._processId
        };
    }
}
